import { Fragment, ReactNode } from 'react';
import Loader from './Loader';

const AsyncComponent = ({ isLoading, children }: { isLoading: boolean; children: ReactNode }) => {
    return <Fragment>{isLoading ? <Loader className="w-4 h-4" /> : children}</Fragment>;
};

export default AsyncComponent;
